"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageBox = void 0;
const _ = __importStar(require("lodash"));
const vue_1 = __importDefault(require("vue"));
const vue_property_decorator_1 = require("vue-property-decorator");
const message_box_html_1 = __importDefault(require("./message-box.html"));
let MessageBox = class MessageBox extends vue_1.default {
    activeElement;
    $refs;
    modalName;
    header;
    message;
    details;
    type;
    data() {
        return {
            messages: _.isString(this.message) ? [this.message] : this.message
        };
    }
    beforeMount() {
        this.activeElement = document.activeElement;
        window.addEventListener('keyup', this.onKeyUp);
    }
    mounted() {
        this.$refs.container.focus();
    }
    beforeDestroy() {
        window.removeEventListener('keyup', this.onKeyUp);
        if (this.activeElement instanceof HTMLElement) {
            this.activeElement.focus();
        }
        this.activeElement = null;
    }
    get headerClass() {
        if (this.type === 'error') {
            return 'bg-danger text-light';
        }
        return 'bg-info';
    }
    close($event) {
        this.$imodal.close(this.modalName, {});
    }
    onKeyUp(event) {
        if (event.which === 27) {
            event.stopPropagation();
            this.close(event);
        }
    }
};
exports.MessageBox = MessageBox;
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", String)
], MessageBox.prototype, "modalName", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null }),
    __metadata("design:type", String)
], MessageBox.prototype, "header", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ required: true }),
    __metadata("design:type", Object)
], MessageBox.prototype, "message", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)(),
    __metadata("design:type", String)
], MessageBox.prototype, "details", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: 'info' }),
    __metadata("design:type", String)
], MessageBox.prototype, "type", void 0);
exports.MessageBox = MessageBox = __decorate([
    (0, vue_property_decorator_1.Component)({ template: message_box_html_1.default })
], MessageBox);
//# sourceMappingURL=message-box.js.map